import {createMuiltLanguagesJson} from "@/components/widgets/nav/repeatNumber.js";


export function supportRtlOfMarginInNodeByFieldName(node, fieldName){

  var marginLeftNumber_diannao = node.data.design['self_marginLeft'].diannao
  var marginRightNumber_diannao = node.data.design['self_marginRight'].diannao
  node.data.design['self_marginLeft'].diannao = createMuiltLanguagesJson(marginLeftNumber_diannao, {
    'rtl': marginRightNumber_diannao
  })
  node.data.design['self_marginRight'].diannao = createMuiltLanguagesJson(marginRightNumber_diannao, {
    'rtl': marginLeftNumber_diannao
  })

  var marginLeftNumber_pingban = node.data.design['self_marginLeft'].pingban
  var marginRightNumber_pingban = node.data.design['self_marginRight'].pingban
  node.data.design['self_marginLeft'].pingban = createMuiltLanguagesJson(marginLeftNumber_pingban, {
    'rtl': marginRightNumber_pingban
  })
  node.data.design['self_marginRight'].pingban = createMuiltLanguagesJson(marginRightNumber_pingban, {
    'rtl': marginLeftNumber_pingban
  })

  var marginLeftNumber_shouji = node.data.design['self_marginLeft'].shouji
  var marginRightNumber_shouji = node.data.design['self_marginRight'].shouji
  node.data.design['self_marginLeft'].shouji = createMuiltLanguagesJson(marginLeftNumber_shouji, {
    'rtl': marginRightNumber_shouji
  })
  node.data.design['self_marginRight'].shouji = createMuiltLanguagesJson(marginRightNumber_shouji, {
    'rtl': marginLeftNumber_shouji
  })


  return node
}

export function supportRtlOfTextAlignInNodeByFieldName(node, fieldName){
  if(node.data.design[fieldName].diannao === 'left'){
    node.data.design[fieldName].diannao = createMuiltLanguagesJson('left', {
      'rtl': 'right'
    })
  }

  if(node.data.design[fieldName].pingban === 'left'){
    node.data.design[fieldName].pingban = createMuiltLanguagesJson('left', {
      'rtl': 'right'
    })
  }

  if(node.data.design[fieldName].shouji === 'left'){
    node.data.design[fieldName].shouji = createMuiltLanguagesJson('left', {
      'rtl': 'right'
    })
  }
  return node
}

export function supportRtlInNode(node) {
  if (node.componentName === 'text_title' || node.componentName === 'text_paragraph') {
    node = supportRtlOfTextAlignInNodeByFieldName(node, 'title_textAlign')
    node = supportRtlOfMarginInNodeByFieldName(node)
  } else if (node.componentName === 'button_text') {
    node = supportRtlOfTextAlignInNodeByFieldName(node, 'self_textAlign')
    node = supportRtlOfMarginInNodeByFieldName(node)
  } else if (node.componentName === 'button_text_icon') {
    node = supportRtlOfTextAlignInNodeByFieldName(node, 'self_flexAlign')
    node = supportRtlOfMarginInNodeByFieldName(node)
  } else {
    node = supportRtlOfMarginInNodeByFieldName(node)
  }

  return node
}
